/* eslint-disable react/rules-of-hooks */
import { create } from 'zustand'

interface SettingsState {
  isSoundEnabled: boolean
  allowSound: boolean
}

interface SettingsStore extends SettingsState {
  toggleSound: () => void
  enableSound: () => void
  disableSound: () => void
  setAllowSound: (allow: boolean) => void
}

export const useSettingsStore = create<SettingsStore>()(set => ({
  isSoundEnabled: false,
  allowSound: false,
  toggleSound: () => set((state) => {
    const newSoundState = !state.isSoundEnabled

    // If trying to enable sound, check for tutorial mode or protection period
    if (newSoundState) {
      if (typeof window !== 'undefined' && window.__tutorialMode) {
        return { isSoundEnabled: false } // Keep it disabled
      }

      // Protection: Don't enable sound for the first 2 seconds
      if (!state.allowSound) {
        return { isSoundEnabled: false } // Keep it disabled
      }
    }

    return { isSoundEnabled: newSoundState }
  }),
  enableSound: () => set((state) => {
    // Protect against enabling sound during tutorial
    if (typeof window !== 'undefined' && window.__tutorialMode) {
      return {}
    }

    // Protection: Don't enable sound for the first 2 seconds
    if (!state.allowSound) {
      return {}
    }
    return { isSoundEnabled: true }
  }),
  disableSound: () => set(() => ({ isSoundEnabled: false })),
  setAllowSound: (allow: boolean) => set(() => ({ allowSound: allow })),
}))

export const useIsSoundEnabled = () => useSettingsStore(state => state.isSoundEnabled)
export const useToggleSound = () => useSettingsStore(state => state.toggleSound)
export const enableSound = () => useSettingsStore(state => state.enableSound)
export const disableSound = () => useSettingsStore(state => state.disableSound)
